/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxMaskedInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxmaskedinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcMaskedInputComponent),
    multi: true
};

/**
 * Masked Input
 */
@Component({
    selector: 'ngc-maskedinput',
    template: `<jqxMaskedInput *ngIf="visible" (onChange)="inputChange($event)"
                [disabled] = "disabled"
                [mask] = "mask"
                [promptChar] = "promptChar"
                [readOnly] = "readOnly"
                [rtl] = "rtl"
                [theme] = "theme"
                [textAlign] = "textAlign"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxMaskedInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcMaskedInputComponent extends ControlComponent {
    @Input('mask') mask: any;
    @Input('promptChar') promptChar: any;
    @Input('readOnly') readOnly: any;
    @Input('rtl') rtl: any;
    @Input('theme') theme: any;
    @Input('textAlign') textAlign: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
}

/**
 * MaskedInput Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcMaskedInputComponent],
    declarations: [NgcMaskedInputComponent, jqxMaskedInputComponent]
})
export class NgcMaskedInputModule {
}